import { Select } from 'antd'
import { SelectProps } from 'antd/lib'
import { useMemo } from 'react'

import { useClassifierServiceGetCuatmClassifierElementListEndpoint } from 'src/api/queries'
import { ClassifierCategory, ClassifierType } from 'src/api/requests'
import { DEFAULT_ONE_HUNDRED_PER_PAGE } from 'src/app-constants'
import { useClassifierId } from 'src/hooks'
import { useLocales } from 'src/locales'
import { getLocalizedTitle } from 'src/utils'

export const RegionSelect = (props: SelectProps) => {
  const { t, currentLang } = useLocales()

  const cuatmClassifierId = useClassifierId(
    ClassifierType.CUATM,
    ClassifierCategory.DIAGNOSTIC
  )

  const { data, isLoading } =
    useClassifierServiceGetCuatmClassifierElementListEndpoint(
      {
        id: String(cuatmClassifierId),
        pageNumber: 1,
        pageSize: DEFAULT_ONE_HUNDRED_PER_PAGE,
        hasParent: false
      },
      [String(cuatmClassifierId)],
      { enabled: !!cuatmClassifierId }
    )

  const options = useMemo(() => {
    return data?.data
      ?.map((item) => ({
        value: item.id,
        label: getLocalizedTitle({ item, currentLang: currentLang.value, t })
      }))
      .toSorted((a, b) =>
        (a.label ?? '').localeCompare(b.label ?? '', currentLang.value)
      )
  }, [data])

  return (
    <Select
      allowClear
      showSearch
      optionFilterProp="label"
      options={options}
      popupMatchSelectWidth={false}
      loading={isLoading}
      {...props}
    />
  )
}
